import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotFound, RouteWithSubRoutes } from '@cordata/buffet';

import Index from './collection';

const ConfiguredReportsRoot = ({ routes }) => {
  const { path, url } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route
          exact
          path={url}
          render={() => <Index />}
        />

        {routes.map(r => (
          <RouteWithSubRoutes key={r.path} {...r} path={`${path}/${r.path}`} />
        ))}

        <Route path="*"><NotFound isRoute /></Route>
      </Switch>
    </>
  );
};

ConfiguredReportsRoot.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default ConfiguredReportsRoot;
